"use client";

export default function Photos() {
  return <section className="bg-light-background py-16 px-4 sm:px-6 lg:px-8 !bg-[url(https://vanessabrian.com/wp-content/uploads/2026/02/background-3.jpg)]">
      <div className="mx-auto max-w-7xl flex justify-center items-center">
        <img src="https://vanessabrian.com/wp-content/uploads/2026/02/image_gnc87yph.png" alt="Vanessa and Brian" className="rounded-lg shadow-medium max-w-full h-auto" />
      </div>
    </section>;
}